export function formatCountdown(endDate) {
  if (!endDate) return null;
  const now = Date.now();
  const end = new Date(endDate).getTime();
  if (isNaN(end)) return null;
  const diff = end - now;

  if (diff <= 0) return null;

  const hours = Math.floor(diff / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);

  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes} mins`;
  return `${seconds}s`;
}
